var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var logoutSlice = {
    logoutRequest: function (state) {
        return __assign(__assign({}, state), { pending: true });
    },
    logoutRequestSuccess: function (state) { return (__assign(__assign({}, state), { pending: false, userInfo: undefined, isSigningOut: true, error: null, menus: undefined, background: undefined, isAuthenticated: false })); },
    logoutRequestFailed: function (state, action) { return (__assign(__assign({}, state), { pending: false, error: action.payload.error })); },
};
